import React, { Component } from "react";
import {
  Modal,
  FormGroup,
  Button,
  FormCheck,
  FormLabel,
  Row,
} from "react-bootstrap";
import axios from "axios";
import { setInStorage, getFromStorage } from "../../../utils/storage";
import { toast } from "react-toastify";

const url = "https://w2vramif16.execute-api.us-east-1.amazonaws.com/prod";

export default class CardDialog extends Component {
  state = {
    value: "bKash",
    isConfirming: false,
    cost: "0",
  };

  //Error Notification
  notifyError = (error) => {
    toast.error("" + error.toString());
  };

  //Grant token
  grantToken = () => {
    this.setState({ isConfirming: true }, () => {
      const body = {
        task: "grantToken",
      };
      const headers = {
        "Content-Type": "application/json",
      };
      axios
        .post(
          "https://w2vramif16.execute-api.us-east-1.amazonaws.com/prod",
          body,
          headers
        )
        .then((res) => {
          if (!res.data.errorMessage) {
            setInStorage("card_token", res.data);
            this.createPayment(res.data);
          }
        })
        .catch((err) => {
          this.notifyError(err.toString());
          this.setState({ isConfirming: false });
        });
    });
  };

  //create payment
  createPayment = (token_id) => {
    const num =
      getFromStorage("patient") +
      getFromStorage("appointments").doc_id +
      new Date().getTime();
    let body = {};

    if (
      getFromStorage("keyLogin") &&
      getFromStorage("keyLogin").task === "patient"
    ) {
      body = {
        task: "createPaymentBackend",
        amount: this.props.cost.toString(),
        merchantInvoiceNumber: `${num}`,
        token_id,
        rateField: this.props.rateField,
        doctor_id: `${getFromStorage("appointments").doc_id}`,
        patient_id: getFromStorage("patient")
      };
    } 
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .post(
        "https://w2vramif16.execute-api.us-east-1.amazonaws.com/prod",
        body,
        headers
      )
      .then((res) => {
        if (!res.data.errorMessage && res.data.message !== "Unauthorized") {
          if (
            res.data.merchantInvoiceNumber === num &&
            res.data.amount.toString() === this.props.cost.toString() &&
            res.data.intent === "sale"
          ) {
            setInStorage("inv_num", res.data.merchantInvoiceNumber);
            setInStorage("pay_time", res.data.paymentCreateTime);
            setInStorage("amount", res.data.amount);
            setInStorage("intent", res.data.intent);
            setInStorage("bkash", res.data);
            window.location = res.data.bkashURL;
          } else {
            this.notifyError("Some details donot matches");
          }
        } else {
          this.notifyError("Unauthorized");
        }
        this.setState({ isConfirming: false });
      })
      .catch((err) => {
        this.notifyError(err.toString());
        this.setState({ isConfirming: false });
      });
  };

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{ marginBottom: "-100px" }}>
            Secure Payment
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            {this.props.message} tk. This amount will be transferred from your
            account.
          </p>
          <form>
            <FormGroup controlId="card">
              <FormLabel style={{ fontWeight: "bold" }}>Choose Card:</FormLabel>
              <Row style={{ marginLeft: "1px" }}>
                <FormCheck
                  type="radio"
                  label="bKash"
                  value={this.state.value}
                  checked={this.state.value === "bKash"}
                  onChange={() => this.setState({ value: "bKash" })}
                />
                <img
                  src={require("../../../image/bkash.png")}
                  alt="bkash"
                  style={{ height: "25px", width: "60px" }}
                />
              </Row>
            </FormGroup>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            onClick={this.props.handleClose}
          >
            Close
          </Button>
          <Button
            variant="success"
            size="sm"
            onClick={this.grantToken}
            disabled={this.state.isConfirming}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
